import { render, staticRenderFns } from "./GstPayWithHoldingDetail.vue?vue&type=template&id=06698bde&scoped=true"
import script from "./GstPayWithHoldingDetail.vue?vue&type=script&lang=js"
export * from "./GstPayWithHoldingDetail.vue?vue&type=script&lang=js"
import style0 from "./GstPayWithHoldingDetail.vue?vue&type=style&index=0&id=06698bde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06698bde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06698bde')) {
      api.createRecord('06698bde', component.options)
    } else {
      api.reload('06698bde', component.options)
    }
    module.hot.accept("./GstPayWithHoldingDetail.vue?vue&type=template&id=06698bde&scoped=true", function () {
      api.rerender('06698bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstPayWithHoldingDetail.vue"
export default component.exports